export default ({ name }) => {
  return (
    <div className={`booking u-site-width content-block  u-color-white court__inner court-1`}>
      <div className={`court__header !m-0`}>
        <img src={'https://padel-if-module.web.app/assets/mini-court.svg'} alt="" />
        <h5 className="court__title">{name}</h5>
      </div>
    </div>
  );
};
